@if(variant === 'button') {
<button (click)="toggleTheme(themeService.getTheme() !== 'dark') " [ngClass]="buttonClass"
    class="p-2 rounded-lg transition-all duration-300 hover:bg-purple-100 text-slate-600 hover:text-purple-600 dark:hover:bg-slate-800/50 dark:text-slate-300 dark:hover:text-white">
    @if(themeService.getTheme() === 'dark') {
    <app-icon name="moon" [size]="20"></app-icon>
    } @else {
    <app-icon name="sun" [size]="20"></app-icon>
    }
</button>
} @else {
<app-toggle [checked]="themeService.getTheme() === 'dark'" [useIcons]="true"
    (toggleChange)="toggleTheme($event)"></app-toggle>
}
